import { inject, Injectable } from '@angular/core';
import { FirestoreService } from './firestore.service';
import { shareReplay, Observable, map, switchMap } from 'rxjs';
import { Id } from '@models';
import { TenantContextService } from './tenant-context.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsMasterService {
  private readonly firestore = inject(FirestoreService);
  private readonly tenantContext = inject(TenantContextService);

  settings$ = this.tenantContext.tenantId$.pipe(
    switchMap((tenantId) =>
      this.firestore.getDocument<any>(
        this.tenantContext.collections.MASTERS,
        'settings',
      ),
    ),
    shareReplay(1),
  );

  getSetting<T = any>(id: Id): Observable<T> {
    return this.settings$.pipe(map((settings) => settings?.[id]));
  }
}
